import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
const getLanguageFallBackLng = () => {
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const lng =  ['en-us', 'zh-hk', 'zh-cn'].includes(pathSegments?.[0]) ? pathSegments?.[0] : 'en-us'
  document.documentElement.lang = lng
  return lng
}
export function initializeLanguage() {
  // const searchParams = new URLSearchParams(window.location.search);
  // const UIC = searchParams.get("UIC")?.toLowerCase();
  // const lang = UIC === "en-us" ? "en" : UIC === "zh-cn" ? "cn" : "zh";
 
  i18n.changeLanguage(getLanguageFallBackLng());
}

i18n
  .use(Backend) // 懒加载翻译文件
  // .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 初始化react-i18next
  .init({
    lng: getLanguageFallBackLng(),
    fallbackLng: 'en-us', // 默认语言
    // eslint-disable-next-line no-undef
    debug: process.env.NODE_ENV === 'development', // 开发模式开启调试
    interpolation: {
      escapeValue: false, // React xss
      formatSeparator: ',',
      defaultVariables: {
        WCIP_URL: window.globalConfig.VITE_WCIP_URL,
    }
    },
    
    backend: {
        /* translation file path */
        loadPath: `/login/assets/i18n/translations/{{lng}}.json`
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
    }
  });

export default i18n;